/**
 * Status for a statistic to indicate its availability.
 * tag: 2477
 * @readonly
 * @enum {number} (int)
 */
export enum MDStatisticStatus {
  /** Active (default) */
  Active = 1,
  /** Inactive (not disseminated) */
  Inactive = 2,
}
